export default __webpack_public_path__ + "static/anuPrasad4-ca9a17405b3347c70194f9c7ac9b6c6f.jpg";